import React, { useState } from 'react';
import { useParams, useLocation } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
import CommonBreadcrumb from '../../components/shared/breadcrumb/CommonBreadcrumb';
import { useGetUserAccountsQuery } from '../../app/userApi/userApi';
import { formatDateToMDY } from '../../helpers/Utils';
import Button from '../../components/shared/buttons/button';
import { Col, Row } from 'react-bootstrap';
import Loader from '../../components/shared/loader/Loader';
const UserDetails = () => {
  const navigate = useNavigate()
  const location = useLocation();
  const userEmail = location.state?.userEmail;
  const { id } = useParams();
  const { data: Accountdata, isLoading: accountLoading } = useGetUserAccountsQuery(
    { email: userEmail },
    {skip : !userEmail}
  );

  const breadcrumbItems = [
    { label: 'Users', path: '/users' },
    { label: `User Details - ${id}` }, // last one (no path) is the current page
  ];

if (accountLoading) {
    return <Loader />;
  }

  return (

    <div>
      <CommonBreadcrumb items={breadcrumbItems} />
   
      <Row className='userAcounts'>
        {Accountdata?.data.map((curElem, index) => {
          return (
            <Col lg={6} key={index} >
            <div className='active accountINfo'>
              <div className='d-flex align-items-center justify-content-between'>
                <div>
                  {curElem?.name}
                  <span className='d-block timeCreate'>
                  Create At : <strong> {formatDateToMDY(curElem?.create_date)}</strong>
                  </span>
                </div>
                <Button label="View Surveys" size={"xs"} onClick={() => {navigate(`/users/user-survey/${id}/${curElem?.id}`)}} />
            
              </div>
              </div>
            </Col>
          )
        })}
      </Row>

      
    </div>
  );
};

export default UserDetails;
